/** @format */

/**
 * path 约定（react-router-dom@6.3）：
 * - ✅ `/foo/:id` 必填参数
 * - ❌ `/foo/:id?` 可选参数（匹配失败会进 `*` → `/`）
 * - 可选值用 query（`?id=`）或 navigate 的 location.state
 */
const routeDescriptions = [
  // auth
  {
    key: 'Login',
    routerName: 'auth',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/',
    title: '登录',
  },
  {
    key: 'ForgetPassword',
    routerName: 'auth',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/forget-password',
    title: '忘记密码',
  },
  {
    key: 'Register',
    routerName: 'auth',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/register',
    title: '注册',
  },
  // app - right
  {
    key: 'Welcome',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/',
    title: '欢迎',
  },
  {
    key: 'Chat',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/chat/:chat_id',
    title: '聊天',
  },
  {
    key: 'User',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/user/:user_id',
    title: '好友名片',
  },
  {
    key: 'UpdateContact',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/update-contact/:user_id',
    title: '设置备注',
  },
  {
    key: 'GroupChatDetail',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/group-chat-detail/:chat_id',
    title: '群聊详情',
  },
  {
    key: 'AddGroupMember',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/add-group-member/:chat_id',
    title: '加入联络人',
  },
  {
    key: 'RemoveGroupMember',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/remove-group-member/:chat_id',
    title: '移除联络人',
  },
  {
    key: 'AddGroupChat',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: true,
    visibleInFooter: false,
    path: '/add-group-chat',
    title: '发起群聊',
    icon: {
      type: 'mdi',
      name: 'plusBox',
    },
  },
  {
    key: 'AddContact',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: true,
    visibleInFooter: false,
    path: '/add-contact',
    title: '添加好友',
    icon: {
      type: 'mdi',
      name: 'accountPlus',
    },
  },
  {
    key: 'BasicInfo',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/basic-info',
    title: '个人信息',
  },
  {
    key: 'Avatar',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/avatar',
    title: '修改头像',
  },
  {
    key: 'UpdateCurrentUserDisplayName',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/update-current-user-display-name',
    title: '修改昵称',
  },
  {
    key: 'UpdateCurrentUserEmail',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/update-current-user-email',
    title: '修改电子邮箱',
  },
  {
    key: 'CurrentUserQrcode',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/current-user-qrcode',
    title: '我的二维码',
  },
  {
    key: 'GroupChatQrcode',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/group-chat-qrcode/:chat_id',
    title: '群二维码',
  },
  {
    key: 'UpdateGroupTitle',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/update-group-title/:chat_id',
    title: '修改群聊名称',
  },
  {
    key: 'UpdateCurrentUserGender',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/update-current-user-gender',
    title: '修改性别',
  },
  {
    key: 'Setting',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/setting',
    title: '设置',
  },
  {
    key: 'PrivacyAndSafety',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/privacy-and-safety',
    title: '隐私安全',
  },
  {
    key: 'BlackList',
    routerName: 'app',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '/black-list',
    title: '黑名单',
  },
  // app - left
  {
    key: 'ChatList',
    routerName: 'app',
    visibleInFooter: true,
    isLeftPanel: true,
    isPlusButtonPopup: false,
    path: '/chat-list',
    title: '聊天',
    icon: {
      type: 'iyes',
      name: 'liaotian',
    },
  },
  {
    key: 'ContactList',
    routerName: 'app',
    visibleInFooter: true,
    isLeftPanel: true,
    isPlusButtonPopup: false,
    path: '/contact-list',
    title: '联系人',
    icon: {
      type: 'iyes',
      name: 'lianxiren',
    },
  },
  {
    key: 'Wallet',
    routerName: 'app',
    visibleInFooter: true,
    isLeftPanel: true,
    isPlusButtonPopup: false,
    path: '/wallet',
    title: '钱包',
    icon: {
      type: 'mdi',
      name: 'wallet',
    },
  },
  {
    key: 'FriendList',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: true,
    isPlusButtonPopup: false,
    path: '/friend-list',
    title: '新朋友',
  },
  {
    key: 'UserSetting',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/user-setting/:user_id',
    title: '资料设置',
  },
  {
    key: 'UpdateUserDescription',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/update-user-description/:user_id',
    title: '设置备注',
  },
  {
    key: 'Me',
    routerName: 'app',
    visibleInFooter: true,
    isLeftPanel: true,
    isPlusButtonPopup: false,
    path: '/me',
    title: '我',
    icon: {
      type: 'iyes',
      name: 'wode',
    },
  },
  {
    key: 'ForwardMessage',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/forward-message/:chat_id/:message_id',
    title: '选择会话',
  },
  // wallet sub pages
  {
    key: 'BuyCoinList',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/buy-coin-list',
    title: '购买',
  },
  {
    key: 'PayDetail',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/pay-detail/:order_no',
    title: '下单',
  },
  {
    key: 'MyOrderList',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/my-order-list',
    title: '出售',
  },
  {
    key: 'MyOrderCreate',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/my-order-create',
    title: '创建挂单',
  },
  {
    key: 'PeddingOrderLog',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/pedding-order-log/:id',
    title: '成交记录',
  },
  {
    key: 'PeddingOrderDetail',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/pedding-order-detail/:id',
    title: '挂单详情',
  },
  {
    key: 'Exchange',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/exchange',
    title: '充值',
  },
  {
    key: 'ExchangeDetail',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/exchange-detail/:ex_order_no',
    title: '充值详情',
  },
  {
    key: 'ExchangeSuccess',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/exchange-success',
    title: '充值成功',
  },
  {
    key: 'TakeOrders',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/take-orders',
    title: '订单',
  },
  {
    key: 'TakeOrderDetail',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/take-order-detail/:id',
    title: '订单详情',
  },
  {
    key: 'Transfer',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/transfer',
    title: '转账',
  },
  {
    key: 'Receive',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/receive',
    title: '收款',
  },
  {
    key: 'WalletLog',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/wallet-log',
    title: '钱包详情',
  },
  {
    key: 'WalletLogDetail',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/wallet-log-detail/:id',
    title: '流水详情',
  },
  {
    key: 'MyBill',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/my-bill',
    title: '我的账单',
  },
  {
    key: 'Verified',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/verified',
    title: '实名认证',
  },
  {
    key: 'VerifiedSuccess',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/verified-success',
    title: '认证成功',
  },
  {
    key: 'PhoneBinding',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/phone-binding',
    title: '绑定手机',
  },
  {
    key: 'PhoneBindingSuccess',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/phone-binding-success',
    title: '绑定成功',
  },
  {
    key: 'PayAccountManage',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/pay-account-manage',
    title: '收付款',
  },
  {
    key: 'SettingPayMode',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/setting-pay-mode',
    title: '添加收款方式',
  },
  {
    key: 'SettingPayNumber',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/setting-pay-number',
    title: '支付密码',
  },
  {
    key: 'MyComplaint',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/my-complaint',
    title: '我的申诉',
  },
  {
    key: 'MyComplaintDetail',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/my-complaint-detail/:id',
    title: '申诉详情',
  },
  {
    key: 'MyComplaintForm',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/my-complaint-form',
    title: '申诉订单',
  },
  {
    key: 'CreditRating',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/credit-rating',
    title: '信用等级',
  },
  {
    key: 'TutorialMap',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/tutorial-map',
    title: '购买教程',
  },
  {
    key: 'UserNotice',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/user-notice',
    title: '用户须知',
  },
  {
    key: 'Share',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/share',
    title: '分享',
  },
  {
    key: 'SettingDomain',
    routerName: 'app',
    visibleInFooter: false,
    isLeftPanel: false,
    isPlusButtonPopup: false,
    path: '/setting-domain',
    title: '设置',
  },
  {
    key: 'Redirect',
    routerName: 'all',
    isLeftPanel: false,
    isPlusButtonPopup: false,
    visibleInFooter: false,
    path: '*',
    title: '跳转',
  },
];

export default routeDescriptions;
